import { DataStore, Predicates } from "@aws-amplify/datastore";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import capitalizeFirst from '../../../../../components/common/capitalizeFirst';
import LeftSideBar from '../../../../../components/common/hr/leftnav.component';
import TopNav from '../../../../../components/common/hr/topnav.component';
import { ValidateHRRole } from '../../../../../components/helper/validateRole';
import { Roles, TeamType } from '../../../../../models';
import HRLogin from '../../../../../setup/auth/hr.component';
import Select from 'react-select';
import { ConvertEnumteamToArray } from '../../../../../components/helper/commonfunctions';
import { graphQLGetAllData, graphQLFindRecordById } from '../../../../../components/helper/graphQLFunctions';
import * as mutations from '../../../../../graphql/mutations';
import * as queries from '../../../../../graphql/queries';
import { API, graphqlOperation } from 'aws-amplify';


export default function HrCreateRole() {
    //Validate User Logged In
    const [isAuthenticated, userHasAuthenticated] = useState(true);
    const [showPleaseWaitButton, setPleaseWaitButton] = useState(false);
    const { editRoleId } = useParams();
    const [isEditMode, setEditMode] = useState(false);
    const [isReporteeChecked, setReporteeChecked] = useState(false);
    const [roleId, setRoleId] = useState("");
    const [teamlist, setTeamList] = useState("");
    const [teamId, setTeamId] = useState("");
    const [teamName, setTeamName] = useState({ label: 'Sales', value: "S" });

    let navigateTo = useNavigate();

    //state
    const [role, setRole] = useState("");
    const [level, setLevel] = useState("");

    //Create Record
    const saveRole = async () => {
        if (role === "") { toast.error("Please enter Role."); return; }
        else if (level === "" || level === null) { toast.error("Please select Level."); return; }

        setPleaseWaitButton(true);
        if (isEditMode) {
            //const original = await DataStore.query(Roles, roleId);
            const original = await graphQLFindRecordById('getRoles', roleId);

            // await DataStore.save(
            //     Roles.copyOf(original, (updated) => {
            //         updated.name = capitalizeFirst(role);
            //         updated.sortOrder = parseInt(level);
            //         updated.isReportee = isReporteeChecked;
            //         updated.teamType = teamId ? teamId : 'S';    
            //     })
            // );


            // Update record
            await API.graphql({
                query: mutations.updateRoles,
                variables: {
                    input: {
                        id: original.id,
                        name: capitalizeFirst(role),
                        sortOrder: parseInt(level),
                        isReportee: isReporteeChecked,
                        teamType: teamId ? teamId : 'S',
                        _version: original._version,
                    }
                }
            });

            toast.success("Updated");
        } else {
            console.log(JSON.stringify(teamId) + 'teamId')
            // await DataStore.save(new Roles({ "name": capitalizeFirst(role), "sortOrder": parseInt(level), "isReportee": isReporteeChecked, "teamType": teamId ? teamId : 'S' }));
            // toast.success("Added");

            await API.graphql(
                graphqlOperation(mutations.createRoles, {
                    input: {
                        name: capitalizeFirst(role),
                        sortOrder: parseInt(level),
                        isReportee: isReporteeChecked,
                        teamType: teamId ? teamId : 'S',
                    }
                })
            );

            toast.success("Created");
        }
       
        setPleaseWaitButton(false);
        navigateTo("/hr/settings/role");
    };


    async function onLoad() {
        try {
            if (!ValidateHRRole()) { userHasAuthenticated(false); }

            //Team List
            var teamArray = [];
            teamArray = ConvertEnumteamToArray({B: 'B', S: 'S', P: "P"});
            console.log(JSON.stringify(teamArray))
            setTeamList(teamArray);

            //Edit existing record
            if (editRoleId != null) {
                setRoleId(editRoleId);
                //const original = await DataStore.query(Roles, editRoleId);
                const original = await graphQLFindRecordById('getRoles', editRoleId);

                if (original != null) {
                    setRole(original.name);
                    setLevel(original.sortOrder);
                    setReporteeChecked(original.isReportee)
                    setTeamId(original.teamType)
                    if (original.teamType === 'B') {
                        setTeamName({ label: 'Business', value: original.teamType })
                    } else {
                        setTeamName({ label: 'Sales', value: original.teamType })
                    }
                    setEditMode(true);
                }
                else {
                    toast.error('Invalid record.');
                    navigateTo("/hr/settings/role");
                }
            }
        } catch (e) {
            userHasAuthenticated(false);
        }
    }

    //Check Reportee
    function checkBoxChecked() {
        setReporteeChecked(!isReporteeChecked);
    }

    useEffect(() => {
        onLoad();
    }, []);

    return isAuthenticated ? (
        <div>
            <div className="pt-16 xl:h-full lg:h-full md:h-full 2xl:h-full ">
                <TopNav />
                <LeftSideBar />

                <div className="pl-16">
                    <div className="flex grid flex-row flex-wrap justify-center flex-1 gap-4 p-5 pl-5 pr-5 mt-5 align-center 2xl:grid-cols-8 xl:grid-cols-10 lg:grid-cols-8 md:grid-cols-8 sm:grid-cols-1 contract-grid-wrapper">
                        <div className="col-span-6 col-start-3 lg:col-start-3 xl:col-start-3 2xl:col-start-2">
                            <div className="p-3 py-5 bg-white dark:bg-[#2A2E32] rounded-md shadow ">
                                <div className="flex justify-center mt-3 mb-2">
                                    <h2 className="page-title">
                                        {isEditMode ? "Edit" : "Create"} Role
                                    </h2>
                                </div>
                                <div x-data="{tab: 1}"></div>
                                <div className={"block w-full"}>
                                    <div className="px-4" x-show="tab === 1">
                                        <div className="flex grid flex-row flex-wrap flex-1 mb-6 align-center 2xl:grid-cols-1 xl:grid-cols-1 lg:grid-cols-1 md:grid-cols-1 sm:grid-cols-1 gap-x-4">
                                            <div className="relative mb-4">
                                                <label
                                                    htmlFor=""
                                                    className="text-[#344054] text-[14px] font-medium "
                                                >
                                                    Role
                                                    <label
                                                        htmlFor=""
                                                        className="text-[#FF0000] text-[14px] font-medium"
                                                    >
                                                        *{" "}
                                                    </label>
                                                </label>
                                                <input
                                                    value={(role)}
                                                    onChange={(e) => setRole(e.target.value)}
                                                    type="text"
                                                    id=""
                                                    className="text-[16px] rounded-lg  flex-1  border border-[#D0D5DD] w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-500 shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500 mt-1.5 placeholder:text-[#667085] "
                                                    placeholder="Enter Role"
                                                />
                                            </div>
                                        </div>
                                        <div className="flex grid flex-row flex-wrap flex-1 mb-6 align-center 2xl:grid-cols-2 xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-x-4">

                                            <div className="relative mb-4">

                                                <label
                                                    htmlFor=""
                                                    className="text-[#344054] text-[14px] font-medium "
                                                >
                                                    Level
                                                    <label
                                                        htmlFor=""
                                                        className="text-[#FF0000] text-[14px] font-medium"
                                                    >
                                                        *{" "}
                                                    </label>
                                                </label>
                                                <input
                                                    value={level}
                                                    onChange={(e) => setLevel(e.target.value)}
                                                    type="number"
                                                    id=""
                                                    className="text-[16px] rounded-lg  flex-1  border border-[#D0D5DD] w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-500 shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500 mt-1.5 placeholder:text-[#667085] "
                                                    placeholder="Enter Level"
                                                />
                                            </div>
                                            <div className="relative mb-4">
                                                <label className="text-[#344054] text-[14px] font-medium ">
                                                    Select Team
                                                </label>

                                                <Select
                                                    value={teamName}
                                                    options={teamlist}
                                                    onChange={e => {
                                                        setTeamId(e.value)
                                                        setTeamName(e)
                                                    }}
                                                    className="mt-2 my-react-select-container"
                                                    classNamePrefix="my-react-select"
                                                />
                                            </div>
                                            <div className="relative mb-4">
                                                <label
                                                    htmlFor=""
                                                    className="text-[#344054] text-[14px] font-medium mr-2  "
                                                >
                                                    Reportee
                                                </label>
                                                <input
                                                    checked={isReporteeChecked}
                                                    onChange={() => checkBoxChecked()}
                                                    type="checkbox"
                                                    id=""
                                                    className="rounded mr-3 border-[#C8CBD0]"
                                                />

                                            </div>
                                        </div>
                                        <div className="grow flex justify-center gap-3 mb-3">
                                            <Link
                                                to="/hr/settings/role"
                                                className=" py-2 px-5 bg-white text-[#344054] transition ease-in duration-200 text-[14px] text-center font-medium  shadow-md focus:outline-none leading-6  justify-center rounded-lg border border-[#D0D5DD] rounded-md dark:bg-[#4A5056]  dark:border-[#4A5056] dark:text-white"
                                            >
                                                Cancel
                                            </Link>
                                            <button
                                                onClick={() => saveRole()}
                                                className=" py-2 px-6 bg-btn-blue text-[#fff] transition ease-in duration-200 text-[14px] text-center font-medium  shadow-md focus:outline-none leading-6  justify-center rounded-lg border border-[#D0D5DD] rounded-md"
                                            >
                                                {showPleaseWaitButton ? "Please wait..." : "Submit"}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    ) : (
        <HRLogin sessionExpired={1} />
    );
}
